/**
 * #976 — the client mirror of the server's target identity rule
 * (`relay/src/cardAnnotations/target.ts`, `identity()`): 1 to 256 UTF-16 units,
 * no control characters, no lone surrogates. One id that fails it makes the
 * server refuse the WHOLE read batch, so the controllers drop such a target
 * before batching and mark it unavailable instead. Keep this in step with the
 * server rule; do not loosen or tighten it here.
 *
 * Relative imports only: `integration/card-annotations.identity-parity.test.ts` imports this module.
 */
import type { CardNoteTarget } from '../cardNotes/types';

const ID_MAX = 256;
const ID_FORBIDDEN = /[\u0000-\u001F\u007F-\u009F]/;
const wellFormed = (text: string) => !/\p{Surrogate}/u.test(text);

const identityOk = (value: unknown): boolean =>
  typeof value === 'string' && value.length >= 1 && value.length <= ID_MAX
  && !ID_FORBIDDEN.test(value) && wellFormed(value);

/** True when the server would accept this target's id (order id or market id). */
export const cardTargetIdentityValid = (t: CardNoteTarget): boolean =>
  identityOk(t.kind === 'order' ? t.venueOrderId : t.marketId);
